import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { AdPlaceholder } from '../components/AdPlaceholder';
import { SidebarMarketWidget } from '../components/SidebarMarketWidget';
import { Facebook, Twitter, Linkedin, Mail, Printer } from 'lucide-react';
export function Article() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-291" data-mp="xx4mtsbapstv">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-292" data-mp="tvjgyqx6iet6">
        <Header data-id="element-293" data-mp="txni513p0zpr" />
        <Navigation data-id="element-294" data-mp="p4b4tn4gsfcb" />
      </div>

      <MarketTicker data-id="element-295" data-mp="p3jbkiycatp7" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-296" data-mp="p2qb1zpz50fi">
        {/* Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-297" data-mp="k57zs2ohi94c">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Advertisement" data-id="element-298" data-mp="1hldnkqqwn74z" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-299" data-mp="1cs2iau1qqyf6">
          {/* LEFT COLUMN: Article Content */}
          <main className="lg:col-span-8" data-id="element-300" data-mp="1lsaxmcv707e6">
            <h1 className="font-serif text-4xl md:text-[2.75rem] leading-tight text-gray-900 mb-6" data-id="element-301" data-mp="1lqzjpk819j9c">
              Perdue Foods appoints Andy Urban as chief commercial officer
            </h1>

            <div className="mb-6" data-id="element-302" data-mp="1c1g1mgs59tfj">
              <img src="https://placehold.co/800x450/e2e8f0/475569?text=Andy+Urban" alt="Andy Urban" className="w-full h-auto object-cover" data-id="element-303" data-mp="1c0enu4jqusu4" />
              <p className="text-sm text-gray-600 italic text-center mt-2" data-id="element-304" data-mp="12zqa7ay9iuhr">
                Andy Urban, chief commercial officer, Perdue Foods | Source:
                Perdue Foods
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-between border-b border-gray-200 pb-4 mb-6 gap-4" data-id="element-305" data-mp="2jg2x5dhq3kox">
              <div className="text-sm text-gray-600" data-id="element-306" data-mp="2ni6cid7ij9fh">
                04.08.2026 <span className="mx-2" data-id="element-307" data-mp="2nfk1g3leybsi">|</span> By{' '}
                <a href="#" className="text-[#002f5f] hover:underline font-medium" data-id="element-308" data-mp="a9x55mpmi7q">
                  Rachael Oatman
                </a>
              </div>

              <div className="flex items-center gap-2" data-id="element-309" data-mp="3nepujqmbgti4">
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-310" data-mp="3if3i3jebbhad">
                  <Facebook className="w-4 h-4 fill-current" data-id="element-311" data-mp="iz6whnwys0wt" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-312" data-mp="ezegiq58qshf">
                  <Twitter className="w-4 h-4 fill-current" data-id="element-313" data-mp="58bglro1sjjq" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors text-xs font-bold" data-id="element-314" data-mp="56h677aek9tw">
                  in
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-315" data-mp="1583wnog0zfvc">
                  <Mail className="w-4 h-4" data-id="element-316" data-mp="1a7qj8ohqu8gt" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-317" data-mp="1f61soy44mgyi">
                  <Printer className="w-4 h-4" data-id="element-318" data-mp="1j5sdml6z22v4" />
                </button>
              </div>
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 leading-relaxed space-y-6" data-id="element-319" data-mp="1o55be0zdsuch">
              <p data-id="element-320" data-mp="1t3q136h0bvmo">
                SALISBURY, MD. — Perdue Foods appointed Andy Urban as chief
                commercial officer, effective immediately. In this role, he will
                lead the company's commercial organization to drive growth and
                strengthen customer partnerships, overseeing sales, marketing,
                customer development, revenue management and innovation.
              </p>
              <p data-id="element-321" data-mp="1y9lj4z5ztoyv">
                "Andy is a proven commercial leader with a deep understanding of
                our business, our customers and consumers, and our culture,"
                said Kevin McAdams, president and chief executive officer of
                Perdue Farms. "His track record of driving growth, building
                high-performing teams and delivering results makes him
                exceptionally well-suited to lead our commercial organization as
                we continue to evolve and compete in a dynamic marketplace."
              </p>
              <p data-id="element-322" data-mp="1bbqoogjcm1zx">
                With more than 35 years of experience, Urban is seasoned in
                leading complex, multi-channel consumer packaged goods
                businesses, with deep expertise across retail, foodservice,
                club, mass, convenience, industrial and international markets.
              </p>
              <p data-id="element-323" data-mp="2vq0pipr4prv6">
                Since joining Perdue in 2009, Urban has held a series of senior
                leadership roles spanning sales, general management and
                enterprise transformation. Most recently, he served as senior
                vice president of the transformation office, where he led
                initiatives to simplify company operation and improve execution.
                Previously, Urban served as senior vice president and general
                manager of Perdue Premium Meat Co., as well as senior vice
                president and general manager of the prepared foods and turkey
                businesses, where he led multi-billion-dollar portfolios with
                full profit and loss responsibility. Earlier in his career,
                Urban held senior sales leadership roles at Perdue, including
                leading retail sales across all major channels. Before joining
                the company, he worked at WhiteWave Foods and Con Agra Foods.
              </p>
              <p data-id="element-324" data-mp="1owco4od161ng">
                "I'm honored to step into this role at a pivotal time for
                Perdue," Urban said. "This company has a strong foundation, a
                powerful purpose and an incredible team. I look forward to
                working closely with our customers and associates to drive
                sustainable growth and deliver value across the business."
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mt-10 mb-8" data-id="element-325" data-mp="1fs60i6dru7sx">
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-326" data-mp="1ftgzzu06ote8">
                Companies
              </a>
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-327" data-mp="113i6i4jkq653">
                Perdue Farms
              </a>
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-328" data-mp="s33jn0qyoizh">
                People
              </a>
            </div>

            <hr className="border-gray-200 mb-8" data-id="element-329" data-mp="3cq3jxu7ebccu" />

            {/* Related Articles */}
            <div data-id="element-330" data-mp="3hpg5mbmj6ddu">
              <div className="w-16 h-1 bg-[#38bdf8] mb-4" data-id="element-331" data-mp="3hpy99tbivtvs"></div>
              <h3 className="text-2xl font-serif text-gray-900 mb-6" data-id="element-332" data-mp="3hnc2vx0dbkf5">
                Related Articles
              </h3>
              <ul className="space-y-4" data-id="element-333" data-mp="2p0hl57uxqz5d">
                <li data-id="element-334" data-mp="2p1k9p94scpi4">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-335" data-mp="2oyy6floxgw5p">
                    Pilgrim's Europe appoints Matt Lee as chief business officer
                  </a>
                </li>
                <li data-id="element-336" data-mp="21an92sifxem6">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-337" data-mp="21b6hnim7aqnj">
                    Foster Farms appoints new chief commercial officer
                  </a>
                </li>
                <li data-id="element-338" data-mp="uonp2tnsp1l9">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-339" data-mp="upfhjvm3ij7b">
                    Perdue Farms hires chief commercial officer
                  </a>
                </li>
              </ul>
            </div>
          </main>

          {/* RIGHT COLUMN: Sidebar */}
          <aside className="lg:col-span-4 flex flex-col gap-8" data-id="element-340" data-mp="1ijqa0qjhakwg">
            <AdPlaceholder width="w-full" height="h-[250px]" text="Advertisement (300x250)" data-id="element-341" data-mp="1dm6ulnb1o22x" />

            {/* Subscribe Box */}
            <div className="bg-gray-100 border border-gray-200 p-6 text-center" data-id="element-342" data-mp="1ndui5d4hcyz4">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-343" data-mp="21c1akdqnu6re">
                Subscribe Today
              </h3>
              <p className="text-sm text-gray-700 mb-6" data-id="element-344" data-mp="1weiwk8xsd1cj">
                Get your FREE subscription to <em data-id="element-345" data-mp="2fz00235yir3h">Meat+Poultry</em> for the
                latest coverage of ingredients, equipment, food safety, and
                more.
              </p>
              <button className="bg-[#38bdf8] text-white px-6 py-2 rounded font-semibold hover:bg-sky-500 transition-colors w-full max-w-[200px]" data-id="element-346" data-mp="2kw03s7fc3hrf">
                Subscribe
              </button>
            </div>

            <AdPlaceholder width="w-full" height="h-[250px]" text="Advertisement (300x250)" data-id="element-347" data-mp="1x91rlly8yvzb" />

            <SidebarMarketWidget data-id="element-348" data-mp="2211loxrmyunz" />

            {/* Popular Articles */}
            <div data-id="element-349" data-mp="1nbdl5yra401b">
              <div className="flex items-center gap-4 mb-6" data-id="element-350" data-mp="1nbx159xdcecp">
                <h3 className="text-sm font-medium text-[#e8734a] uppercase tracking-wider whitespace-nowrap" data-id="element-351" data-mp="1s9fcf6yuz5nv">
                  Popular Articles
                </h3>
                <div className="h-px bg-gray-300 w-full" data-id="element-352" data-mp="1ec0jhs9ecfr5"></div>
              </div>
              <ul className="space-y-5" data-id="element-353" data-mp="1iaziyxcczkb7">
                <li data-id="element-354" data-mp="3kszprdad6w6k">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-355" data-mp="3ksghypefho69">
                    Triumph Foods readies for $30 million expansion in Missouri
                  </a>
                </li>
                <li data-id="element-356" data-mp="3fuoeqz8c2fmr">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-357" data-mp="3fu56ybced7mg">
                    Chicken nuggets subject of public health alert over possible
                    lead contamination
                  </a>
                </li>
                <li data-id="element-358" data-mp="2mv6hf835hk7">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-359" data-mp="2m1unzu9s1v7">
                    Tyson Foods closing Georgia prepared foods plant
                  </a>
                </li>
                <li data-id="element-360" data-mp="2ft1l697eyth3">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-361" data-mp="2fs8ipkfhmq4r">
                    Hertzog Meat Co. expands with new Butler processing plant
                  </a>
                </li>
              </ul>
            </div>

            {/* Popular Galleries */}
            <div data-id="element-362" data-mp="1ww0964ffzt3n">
              <div className="flex items-center gap-4 mb-6" data-id="element-363" data-mp="1wvh2jjv8sr4x">
                <h3 className="text-sm font-medium text-[#e8734a] uppercase tracking-wider whitespace-nowrap" data-id="element-364" data-mp="1rwdvjtvpcaub">
                  Popular Galleries
                </h3>
                <div className="h-px bg-gray-300 w-full" data-id="element-365" data-mp="26qsa9i88gy36"></div>
              </div>
              <div className="space-y-6" data-id="element-366" data-mp="21sqsd0mjn4ta">
                <div className="flex gap-4 group cursor-pointer" data-id="element-367" data-mp="3i7s9yywwuf78">
                  <img src="https://placehold.co/120x80/e2e8f0/475569?text=MLB" alt="MLB" className="w-24 h-16 object-cover flex-shrink-0" data-id="element-368" data-mp="3ia4qr8qxmjip" />
                  <div data-id="element-369" data-mp="3pb89elr4zs95">
                    <h4 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-1" data-id="element-370" data-mp="3pap1zyz44m9d">
                      MLB menu innovation hits a grand slam
                    </h4>
                    <p className="text-xs text-gray-600 line-clamp-2" data-id="element-371" data-mp="33rvg3r4n27q">
                      New items include locally-inspired dishes and global
                      cuisine.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 group cursor-pointer" data-id="element-372" data-mp="3bk3efwypro55">
                  <img src="https://placehold.co/120x80/e2e8f0/475569?text=Bacon" alt="Bacon" className="w-24 h-16 object-cover flex-shrink-0" data-id="element-373" data-mp="3bise674h8yis" />
                  <div data-id="element-374" data-mp="2nuiwnheaqwxg">
                    <h4 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-1" data-id="element-375" data-mp="2ntzb7qpftqeo">
                      Bacon formulations
                    </h4>
                    <p className="text-xs text-gray-600 line-clamp-2" data-id="element-376" data-mp="10xjgcqszozvh">
                      Snapshots of new belly-centric pork products.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>;
}